<template>
  <div class="full-width-nav">
    <div class="nav-container">
      <!-- <ul class="main-nav">
        <li v-for="item in navItems" :key="item.id" @mouseenter="showDropdown = item.id"
          :class="{ 'active': selectedNav === item.id }">
          <router-link :to="item.path" class="nav-item" @click="selectedNav = item.id">
            <div class="nav-title"> 
              <span >{{ item.title }}</span>
              <span style="color: #ddd;font-size: 16px;margin-top: 5px;">{{ item.enTitle }}</span></div>
          </router-link>

        </li>
      </ul> -->
      <ul class="nav-links">

        <li v-for="item in navItems" :key="item.id" @mouseenter="getShowDropdown(item.id)"
          :class="{ 'active': selectedNav === item.id }">
          <router-link :to="item.path" class="nav-item" @click="selectedNav = item.id">
            <div class="nav-title">
              <span>{{item.title}}</span>
              <!-- <span style="color: #ddd;font-size: 16px;margin-top: 5px;">{{ item.enTitle }}</span> -->
            </div>
          </router-link>

        </li>
        <!-- <li v-for="item in navItems" :key="item.id" @mouseenter="showDropdown = item.id"><a
            href="#">{{ item.title }}</a></li> -->
      </ul>

      <div class="mega-dropdown" @mouseleave="showDropdown = null">
        <transition name="fade">
          <NavMenuItem :navname="showDropdown" class="fade-in" v-fade-in></NavMenuItem>
        </transition>
      </div>
      <!-- <div 
                class="mega-dropdown" 

                v-show="item.columns.length > 0 && showDropdown === item.id"
                @mouseenter=" showDropdown === item.id "
              >
                <div class="dropdown-container">
                  <div class="dropdown-column" v-for="(column, index) in item.columns" :key="index">
                    <h4 class="column-title">{{ column.title }}</h4>
                    <ul class="column-items">
                      <li v-for="subItem in column.items" :key="subItem">
                        <a href="#">{{ subItem }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->

    </div>
  </div>
</template>

<script>
import NavMenuItem from './NavMenuItem.vue';

export default {
  name: 'NavMenu',
  components: { NavMenuItem },
  props: {
    navItems: []
  },
  data() {
    return {
      selectedNav: null,
      showDropdown: null,
    }
  },
  computed: {
  },
  methods:{

    getNavText(title) {
      // 直接拼接键名
      return this.$t(`layout.header.nav.${title}`);
    },
    async getShowDropdown (id){
      this.showDropdown = id
    }
  }
}
</script>

<style scoped lang="scss">
.full-width-nav {
  width: 100%;
  color: #0962d0;
  // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.mega-dropdown {
  position: fixed;
  background: transparent;
  align-items: center;
  z-index: 1000;
 // margin-top: 1px;
  // max-width: 1200px;
   top:90px;
   
  // animation: slideDown 0.6s ease forwards;
   transition: all 0.5s;
    -webkit-transition: all 0.5s;
}

@keyframes slideDown {
    from {
      left:50%;
      top:-100%;
      transform: translate(50%,-100%) ;
    }
    to {
      left:50%;
      transform:translate(50% ,0);
    }
  }

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 992px) {
  .dropdown-container {
    flex-wrap: wrap;
  }

  .dropdown-column {
    flex: 0 0 50%;
    margin-bottom: 20px;

    &:nth-child(2n) {
      border-right: none;
    }
  }
}

@media (max-width: 768px) {
  .main-nav {
    flex-wrap: wrap;
  }

  .main-nav>li {
    flex: 0 0 50%;
  }

  .dropdown-column {
    flex: 0 0 100%;
    border-right: none !important;
  }
}


.nav-links {
  display: flex;
  list-style: none;
  gap: 30px;
}

.nav-links li {
  margin-left: 10px;
  position: relative;


  flex: 1;
  text-align: center;

  &:hover {
    color: #0962d0 !important;
  }

  &.active {
    font-weight: 600;
  }

  .nav-item {
    text-decoration: none;

    .nav-title {
      //color: #000000;
      display: flex;
      flex-direction: column;
     // padding: 20px 0px;
      width: 100px;
      font-weight: 600;
      font-size: 18px;
      text-decoration: none;
      cursor: pointer;
      z-index: 1002;
      margin-bottom: 10px;
    }

  }
}

.nav-links a {
  color: #666;
  text-decoration: none;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  ;
  padding: 5px 0;
}


.nav-links a:after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #3b93ffe5;
  transition: all 0.3s ease;
  ;
}

.nav-links a:hover:after,
.nav-links a.active:after {
  width: 100%;
}


.nav-links a.active,
.nav-links a:hover {
  color: #3b93ffe5;
}

.nav-actions {
  display: flex;
  align-items: center;
}

.nav-links a.active {
  border-bottom :2px  solid #666;
  width: 100%;
}
</style>